// extracted by mini-css-extract-plugin
module.exports = {"quoteItem":"quote_item_quoteItem__LJb4x","quoteItemOpt":"quote_item_quoteItemOpt__AfadB"};